import { getCancellationReasonListRequest } from "../../data/cancellationReasonApi";

export async function getCancellationReasonListUseCase() {
  const response = await getCancellationReasonListRequest();
  return Array.isArray(response?.data) ? response.data : [];
}
